// extracted by mini-css-extract-plugin
module.exports = {"with-footer":"with_footer_with-footer__9YWRq","no-bottom-padding":"with_footer_no-bottom-padding__kouOn"};